<form class="bankAcctForm" novalidate [formGroup]="paymentForm">
  <div
    class="formElem"
    [ngClass]="{'has-error':paymentForm.get('routingNumber').touched &&
                                       !paymentForm.get('routingNumber').valid}"
  >
    <div id="routing-number" class="form__field">
      <basic-text-input
        [propertyName]="'routingNumber'"
        [placeholder]="'Routing number'"
        (valueChanged)="validateRN()"
        [parserType]="'Text'"
        [inputType]="'text'"
        [maxlength]="9"
        type="text"
        formControlName="routingNumber"
        [formGroupComponent]="true"
      ></basic-text-input>
    </div>

    <div class="error">{{rnError}}</div>
  </div>
  <div
    class="formElem"
    [ngClass]="{'has-error':paymentForm.get('accountNumber').touched &&
                                       !paymentForm.get('accountNumber').valid}"
  >
    <div id="account-number" class="form__field">
      <basic-text-input
        [propertyName]="'accountNumber'"
        [placeholder]="'Account number'"
        (valueChanged)="validateAN()"
        [parserType]="'Text'"
        [inputType]="'text'"
        type="text"
        formControlName="accountNumber"
        [formGroupComponent]="true"
      ></basic-text-input>
    </div>

    <div class="error">{{anError}}</div>
  </div>
  <div class="formElem">
    <div id="account-type">
      <select-basic
        [propertyName]="'accountTypeComponent'"
        [label]="'Account Type'"
        [optionValues]="accountTypeOptions"
        (valueChanged)="setAccountBusinessType()"
        formControlName="accountType"
        [formGroupComponent]="true"
      ></select-basic>
    </div>
  </div>
  <div *ngIf="isInvalidPaymentInfo()" class="banking-widget-container">
    <cpds-alert intent="danger" class="banking-widget-alert">
      <span>{{ paymentInfoError }} </span>
    </cpds-alert>
  </div>
</form>
<ng-content></ng-content>
<div class="cta">
  <button type="button" class="btnSubmit" (click)="updateBankInfo()" [disabled]="isDisabled()">Authorize</button>
  <button type="button" class="btnCancel" (click)="cancel();">Cancel</button>
</div>
